import React from 'react';
import { Link } from 'react-router-dom';
import type { Guide } from '../types/content';
interface GuideCardProps {
  guide: Guide;
  featured?: boolean;
}
export function GuideCard({
  guide,
  featured = false
}: GuideCardProps) {
  return <article className="group relative flex h-full flex-col" data-id="element-67" data-mp="b2byd42331la">
      <div className="overflow-hidden bg-creme" data-id="element-68" data-mp="61eiiy4jqjmy">
        <img src={guide.image} alt={guide.imageAlt ?? ''} className={`photo-soft w-full object-cover transition-transform duration-300 ease-soft group-hover:scale-[1.03] ${featured ? 'aspect-[16/10]' : 'aspect-[4/3]'}`} data-id="element-69" data-mp="63qxd2f0cdvs" />
      </div>

      <div className="flex flex-1 flex-col pt-6" data-id="element-70" data-mp="tqh1c9ax2ij1">
        <p className="label text-olive" data-id="element-71" data-mp="orvw1vgt58nq">
          {guide.category}
          {guide.sponsored && <span className="ml-3 text-muted" data-id="element-72" data-mp="12rf3sn5pihzi">· Partner</span>}
        </p>
        <h3 className={`mt-3 font-display font-300 leading-[1.08] text-ink ${featured ? 'text-[40px] lg:text-[48px]' : 'text-[26px]'}`} data-id="element-73" data-mp="12pkg5131wbrq">
          <Link to="/place" className="decoration-olive decoration-1 underline-offset-[7px] after:absolute after:inset-0 after:content-[''] group-hover:underline" data-id="element-74" data-mp="3cmmn3quxjemx">
            {guide.title}
          </Link>
        </h3>
        <p className={`mt-4 leading-[1.75] text-muted ${featured ? 'max-w-xl text-[16px]' : 'text-[14.5px]'}`} data-id="element-75" data-mp="3qkusmn617o9p">
          {guide.deck}
        </p>
      </div>
    </article>;
}